import request from 'config/apiConfig';
import { ICompleteProfilePayload, IInviteAccountPayload } from './types';

export const putMediaContent = (payload: FormData, id: string, category: string) => {
  return request.put(`content/assets/${category}/${id}`, payload);
};

export const updateCompanyLogo = (marketerId: string, url: string) => {
  return request.put(`partner/marketers/${marketerId}/logo`, { logo: url });
};

export const updateCompanyCoverImage = (marketerId: string, url: string) => {
  return request.put(`partner/marketers/${marketerId}/cover`, { cover: url });
};

export const updateCompanyWebsite = (marketerId: string, website: string) => {
  return request.put(`partner/marketers/${marketerId}/website`, { website: website });
};

export const updateCompanyName = (marketerId: string, username: string) => {
  return request.put(`partner/marketers/${marketerId}/name`, { name: username });
};

export const updateProfileImage = (employeeId: string, payload: FormData) => {
  return request.put(`content/assets/display/b8deadfc-cab6-4586-9d75-45078110f441`, payload);
};

export const updateProfileName = (employeeId: string, name: string) => {
  return request.put(`profile/employees/${employeeId}/name`, { name: name });
};

export const inviteAccount = (payload: IInviteAccountPayload) => {
  return request.post('partner/accounts/add', payload);
};

export const completeProfile = (payload: ICompleteProfilePayload) => {
  return request.put('partner/employees/profile/complete', payload);
};
